import * as React from "react"
import styled from "styled-components"
import { MinusIcon } from "../atoms/icons/MinusIcon"
import { Spacer } from "../atoms/spacers"
import Body from "../atoms/typography/Body"
import { AddIcon } from "../atoms/icons/AddIcon"
import { theme } from "../theme"

interface Props {
  currentValue: number
  onClickMinus: () => void
  onClickAdd: () => void
  minValue?: number
  maxValue?: number
}

const ContentContainer = styled.div`
  display: flex;
  align-items: center;
`

const IconContainer = styled.div<{ disabled?: boolean }>`
  cursor: ${(props) => (props.disabled ? undefined : "pointer")};

  :hover {
    filter: ${(props) => (props.disabled ? undefined : "opacity(0.6)")};
  }
`

const Counter: React.FC<Props> = ({ currentValue, onClickMinus, onClickAdd, minValue = 0, maxValue }) => {
  const negDisabled: Boolean = currentValue <= minValue
  const maxDisabled: Boolean = maxValue ? currentValue >= maxValue : false

  return (
    <div>
      <ContentContainer>
        <IconContainer onClick={negDisabled ? undefined : onClickMinus} disabled={negDisabled}>
          <MinusIcon color={negDisabled ? theme.colors.greyDisabled : theme.colors.greyDark} />
        </IconContainer>
        <Spacer spacing={1} />
        <Body>{currentValue}</Body>
        <Spacer spacing={1} />
        <IconContainer onClick={maxDisabled ? undefined : onClickAdd} disabled={maxDisabled}>
          <AddIcon color={maxDisabled ? theme.colors.greyDisabled : theme.colors.greyDark} />
        </IconContainer>
      </ContentContainer>
    </div>
  )
}

export default Counter
